const baseUrl = import.meta.env.VITE_CLOUD_FRONT_URL;

const makeBuildingUrl = (id: string) => {
  return `features/buildings/${id}/${id}.glb`;
};

const makePdfOverlayUrl = (id: string) => {
  return `${baseUrl}/features/pdf-overlays/${id}/tiles`;
};

const makePdfOverlayFileUrl = (id: string) => {
  return `${baseUrl}/features/pdf-overlays/${id}/${id}.pdf`;
};

export { makePdfOverlayUrl, makeBuildingUrl, makePdfOverlayFileUrl };
